import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = ['Un plan claro para identificar los 3 químicos que disparan tu cortisol.', 'La Matriz de Sustitución Alimentaria Hormonal para limpiar tu cocina.', 'El Checklist de productos de belleza Zero-Capa para desintoxicar tu rutina diaria.', 'La Escala de Calidad del Sueño Detox para transformar tus noches.', 'El Plan de 7 Días con pasos diarios para eliminar la hinchazón y recuperar tu energía.'];
  return <section className="py-24 bg-cream" data-id="element-173">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-serif text-dark mb-6" data-id="element-176">
            ¿Qué obtienes con Eco-S.O.S. Detox?
          </h2>
          <p className="text-lg text-dark/70" data-id="element-177">
            Todo lo que necesitas para una transformación completa, paso a paso.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-178">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center p-6 bg-white rounded-2xl shadow-sm border border-sage-light hover:border-sage transition-colors group" data-id="element-179">
              <div className="w-10 h-10 rounded-full bg-sage-light flex items-center justify-center shrink-0 mr-6 group-hover:bg-sage group-hover:text-white transition-colors text-sage-dark" data-id="element-180">
                <CheckCircle2 className="w-6 h-6" data-id="element-181" />
              </div>
              <p className="text-dark/80 text-lg font-medium" data-id="element-182">{item}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}